import React, { useEffect, useState } from "react";
import $ from "jquery";
import axios from "axios"; 
import FormValidator from "../../../inc/FormValidator";
import Api from "../../../inc/Api";
import Settings from "../../../inc/Settings";
import Button from "../../inc/Button";
import Collapse from "../../inc/Collapse"; 
import FieldsRenderer from "../../Purchase Orders Internal/Edit PO/FieldsRenderer";
import Helper from "../../../inc/Helper";
import { Form } from "react-bootstrap";
import { getPopupMessageBasedOnStatus } from "../../../inc/Validation";
import Popup from "../../Popup/Popup";
import CommonAPICalls from "../Common Integration Calls/CommonApiCalls";

let cancelTokenSource = axios.CancelToken.source();
const ExternalSystemApiFormsPopup = ({ setClosePopupViewModal, reloadParentGrid }) => { 
  const [popupFormData, setPopupFormData] = useState({});
  const [appMaster, setAppMaster] = useState([]);
 
  const [apiCallBtn, setApiCallBtn] = useState(false);

  useEffect(() => {  
    fetchDataForAppMaster();
  }, [])

  let popupFormValidator;

  const validationConfigure = () => {
    let popupFieldConfig = [
      { name: "api_name", displayName: "Api name", types: ["Required"] },
      { name: "api_endpoint", displayName: "Api endpoint", types: ["Required"] },
      { name: "auth_method", displayName: "Auth method", types: ["Required"] },
      { name: "additional_info", displayName: "Additional info", types: ["Required"] },
      { name: "app", displayName: "Sequence", types: ["Required"] },
      { name: "sequence", displayName: "Credentials", types: ["Required"] }
    ];

    if (!popupFormValidator) {
      popupFormValidator = new FormValidator(popupFieldConfig);
    }
  };

  validationConfigure();
 
  const fetchDataForAppMaster = async () => {
    const apiCalls = new CommonAPICalls();
    try {
      const systemAppMasterResponse = await apiCalls.getSystemAppMaster();
      if (systemAppMasterResponse) {
        setAppMaster(systemAppMasterResponse);
      };
    } catch (error) { 
      setAppMaster([]); 
    }
  }
 
  const fieldsArrayGeneral = [
    {
      className: "col-lg-4",
      label: "Api name",
      inputType: "text",
      required: true,
      id: "api_name",
      name: "api_name",
    },
    {
      className: "col-lg-4",
      label: "Api endpoint",
      inputType: "text",
      required: true,
      id: "api_endpoint",
      name: "api_endpoint",
    },
    {
      className: "col-lg-4",
      label: "Auth method",
      inputType: "text",
      required: true,
      id: "auth_method",
      name: "auth_method",
    },
    {
      className: "col-lg-4",
      label: "Additional info",
      inputType: "text",
      required: true,
      id: "additional_info",
      name: "additional_info",
    },
    {
      className: "col-lg-4",
      label: "App",
      inputType: "dropdown",
      options: appMaster,
      required: true,
      id: "app",
      name: "app",
    },
    {
      className: "col-lg-4",
      label: "Sequence",
      inputType: "number",
      required: true,
      id: "sequence",
      name: "sequence",
    }
  ];

  const onClosePopupClick = () => {
    $("html").removeClass("rs_popup_open");
    setClosePopupViewModal(false);
  };

  const executePOSTPopupDocumentAPI = async () => {
    try { 
      let api = Api;
      api.setUserToken();

      const res = await api
        .axios()
        .post(
          Settings.apiAppUrl + "/external-api/",
          popupFormData,
          { cancelToken: cancelTokenSource.token }
        );

      if (res?.data?.success) {
        Helper.alert(res?.data?.message || 'External system api created successfully', 'success');
        reloadParentGrid();
        onClosePopupClick(); 
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    } catch (error) { 
      getPopupMessageBasedOnStatus(error);
    }
  };

  const handleSubmit = () => {
    if (!popupFormValidator.isValid({ ...popupFormData })) {
      popupFormValidator.displayMessage();
      popupFormValidator.reset();
      return;
    }

    Helper.createDebouncedAPIFunction(
      [executePOSTPopupDocumentAPI],
      setApiCallBtn,
      cancelTokenSource
    )();
  };
  return (
    <Popup
      autoOpen={true}
      width="900px"
      onClose={onClosePopupClick}
    > 
      <>
        <h5 className="create_rfq_modal__title">Create External System Api</h5>

        <Collapse
          className="mt-4 mb-4"
          open={true}
          title={"General Information"}
        >
          <Form>
            <div className="container-fluid">
              <FieldsRenderer
                updateState={setPopupFormData}
                currentState={popupFormData}
                fieldsArray={fieldsArrayGeneral}
              />
            </div>
          </Form>
        </Collapse>
      </> 

      <div
        className="addDocumentNumber-body-buttons"
        style={{ justifyContent: "flex-end" }}
      >
        <Button
          isActive={false}
          title={"Cancel"}
          onClick={onClosePopupClick}
        />
        <Button
          isDisable={apiCallBtn}
          className="solid_btn"
          isActive={true}
          title={<div><span> {"Create"} </span> {apiCallBtn ? <output className="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output> : ''}</div>}
          onClick={handleSubmit}
        />
      </div>
    </Popup>
  );
};

export default ExternalSystemApiFormsPopup;